import lessRequire from '../../../../config/less-require-resolver';
import React from 'react';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';

import { Field, reduxForm } from 'redux-form';

lessRequire('modules/streams/components/filter/search-form.less');

let streamsTimeoutId;

const Form = (props) => {
	const { handleSubmit, applySearch } = props;
	const onSubmit = handleSubmit(d => applySearch(d));

	return (
		<form action="#" className="streams-filters__half-width" onSubmit={onSubmit} >
			<div className="streams-filters__search">
				<Field name="streamsSearch" onSubmit={onSubmit} component={StreamsSearchField} intl={props.intl}/>
			</div>
		</form>
	);
};

const StreamsSearchField = (props) => {
	return (
		<div className={isActive(props)
			? 'form-element streams-search-form-element active'
			: 'form-element streams-search-form-element'}
		>
			<input type="text"
				className="form-element__control font-proxima-nova-regular"
				{...props.input}
				onChange={e => {
					clearTimeout(streamsTimeoutId);
					props.input.onChange(e);
					streamsTimeoutId = setTimeout(() => {
						props.onSubmit();
						props.input.onFocus();
					}, 400);
				}}
			/>
			<label className="form-element__label">{props.intl('Поиск по потокам')}</label>
		</div>
	);
};

const isActive = props => props.meta.active || !isEmpty(props.input.value);

Form.propTypes = {
	input: PropTypes.object,
	handleSubmit: PropTypes.func,
	applySearch: PropTypes.func,
	intl: PropTypes.func
};

StreamsSearchField.propTypes = {
	input: PropTypes.object,
	intl: PropTypes.func,
	onSubmit: PropTypes.func
};

export default reduxForm({
	form: 'filtersStreamsForm'
})(Form);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/streams/components/filter/search-form.js